"use strict";

exports.__esModule = true;
exports.LineChartSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LineTrendsSelector = require("../../LineTrendsSelector");
var _SymbolSelector = require("../../SymbolSelector");
var _AppearanceSelector = require("../../AppearanceSelector");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LineChartSelector = exports.LineChartSelector = function LineChartSelector(props) {
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem;
  (0, _react.useEffect)(function () {
    if (!chartItem || Object.entries(chartItem).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "]",
          value: el.props.chartItems.props[itemIndex] = {}
        };
      });
    }
  }, [chartItem, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "LineChartSelector",
    style: {
      marginBottom: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_LineTrendsSelector.LineTrendsSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex
  }), /*#__PURE__*/_react["default"].createElement(_SymbolSelector.SymbolSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex,
    showSymbolOption: true
  }), /*#__PURE__*/_react["default"].createElement(_AppearanceSelector.AppearanceSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex,
    options: {
      showAreaOption: true,
      showSmoothOption: true,
      showStepOption: true,
      showAxisOptions: true
    }
  }));
};